import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal, Overlay, ScrollArea } from '@mantine/core';

import { useEditBotAllowedUser } from '../../api/editAllowedUser';
import { botTypes } from '../../types';

import { AllowedUserForm } from './AllowedUserForm';

export const EditModal = NiceModal.create(({ user }: { user: botTypes.AllowedUser }) => {
  const modal = useModal();

  const editBotAllowedUser = useEditBotAllowedUser({
    config: { onSuccess: modal.hide },
  });

  return (
    <Modal
      title={user.name}
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={modal.remove}
      closeOnEscape={!editBotAllowedUser.isLoading}
      closeOnClickOutside={!editBotAllowedUser.isLoading}
      withCloseButton={!editBotAllowedUser.isLoading}
      scrollAreaComponent={ScrollArea.Autosize}
    >
      {editBotAllowedUser.isLoading && <Overlay opacity={0} />}
      <AllowedUserForm
        onSubmit={(data) => editBotAllowedUser.mutate({ ...data, _id: user._id })}
        isLoading={editBotAllowedUser.isLoading}
        initialValues={{
          name: user.name,
        }}
      />
    </Modal>
  );
});
